import React from 'react'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'

const CopilotCategoryTitle = ({ children }) => {
  return (
    <DazzedParagraph14 bold color={'var(--text-color-62)'}>
      {children}
    </DazzedParagraph14>
  )
}

export default CopilotCategoryTitle
